import React, { useState, useEffect } from "react";
import axios from "axios";
import PlayButton from "../../../../assets/images/youtubeVideo/play-button.png"; // pastikan path benar
import { config } from "../../../../config";
import "./DesaKami.scss";

const DesaKami = ({ videoUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [embedError, setEmbedError] = useState(false);

  const handlePlay = () => {
    // Tes embed terlebih dahulu dengan men-set isPlaying
    setIsPlaying(true);
  };

  // Helper untuk validasi ID video
  const getYoutubeVideoId = (input) => {
    if (!input) return "";
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)?([\w-]{11})/;
    const match = input.match(regex);
    return match ? match[1] : input;
  };

  const videoId = getYoutubeVideoId(videoUrl);

  return (
    <div
      style={{
        position: "relative",
        textAlign: "center",
        maxWidth: 800,
        margin: "0 auto",
      }}
    >
      {videoId ? (
        <div className="desa-video">
          {isPlaying && !embedError ? (
            <iframe
              width="100%"
              height="350"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              title="Video Profil Desa"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ borderRadius: 12 }}
              onError={() => {
                setEmbedError(true);
                window.open(
                  `https://www.youtube.com/watch?v=${videoId}`,
                  "_blank",
                );
              }}
            />
          ) : (
            <a
              href={`https://www.youtube.com/watch?v=${videoId}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                handlePlay();
              }}
              style={{ display: "block", position: "relative" }}
            >
              <img
                src={`https://img.youtube.com/vi/${videoId}/0.jpg`}
                alt="Thumbnail"
                style={{ width: "100%", borderRadius: 12 }}
              />
              <img
                src={PlayButton}
                alt="Play"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: 150,
                  height: 150,
                  transform: "translate(-50%, -50%)",
                  cursor: "pointer",
                }}
              />
            </a>
          )}
        </div>
      ) : (
        // <p>Video tidak tersedia.</p>
        <></>
      )}
    </div>
  );
};

export default DesaKami;
